import React from 'react';
import Header from '../components/header/index';
import Buttons from '../components/ui-elements/buttons/index';
import Navigation from '../components/navigation/index';
import {ButtonText} from '../typography/typography';
import { CloudDownload, ContactMail, Facebook, GitHub, LinkedIn } from '@material-ui/icons';
import Slide from 'react-reveal/Slide';
import logo from '../logo.png';



export default function HeaderContainer () {
    return (
        <Header id="header">
            <Header.BackgroundVideo src="/videos/video-2.mp4" />
            <Header.Logo to="/" alt="" src={logo} />
            <Navigation top left>
                <Navigation.Item href="#home">
                    <ButtonText>
                        HOME
                    </ButtonText>
                </Navigation.Item>
                <Navigation.Item href="#about">
                    <ButtonText>
                        ABOUT ME
                    </ButtonText>
                </Navigation.Item>
                <Navigation.Item href="#fyp">
                    <ButtonText>
                        FY PROJECT
                    </ButtonText>
                </Navigation.Item>
                <Navigation.Item href="#experience">
                    <ButtonText>
                        EXPERIENCE
                    </ButtonText>
                </Navigation.Item>
                <Navigation.Item href="#projects">
                    <ButtonText>
                        PROJECTS
                    </ButtonText>
                </Navigation.Item>
                <Navigation.Item href="#certifications">
                    <ButtonText>
                        CERTIFICATIONS
                    </ButtonText>
                </Navigation.Item>
            </Navigation>
            <Header.Container>            
                <Header.TextContainer>
                    <Slide left>
                        <Header.Name color="textMain" name="Muzamil Hussain" />
                    </Slide>
                    <Slide right>
                        <Header.Title title="Software Engineer"/>
                    </Slide>
                    <Header.Skills />
                </Header.TextContainer>
                <Buttons>
                    <a style={{textDecoration: "none"}} href = "./MuzamilHussain.pdf" target = "_blank">
                        <Buttons.Button buttonType="secondary" startIcon={<CloudDownload />} ><ButtonText header>DOWNLOAD CV</ButtonText></Buttons.Button>
                    </a>
                    <a style={{textDecoration: "none"}} href="mailto:muzamilsethar@gmail.com">
                        <Buttons.Button buttonType="secondary" startIcon={<ContactMail />}><ButtonText header>CONTACT ME</ButtonText></Buttons.Button>
                    </a>
                </Buttons>
            </Header.Container>
            <Navigation right bottom>
                <Navigation.Item href="https://github.com/Muzamil-Hussain" target = "_blank">
                    <GitHub style={{fontSize: 40}} />
                </Navigation.Item>
                <Navigation.Item href="https://www.linkedin.com/in/muzamil-hussain-830643150/" target = "_blank">
                    <LinkedIn style={{fontSize: 40}} />
                </Navigation.Item>
                <Navigation.Item href="https://www.facebook.com/muzamilsethar/" target = "_blank">
                    <Facebook style={{fontSize: 40}} />
                </Navigation.Item>
            </Navigation>
        </Header>
    )
}